import { useState, useEffect } from 'react'
import { Box, Typography, Grid, FormControl, InputLabel, Input, Button, TextField } from '@mui/material'
import { postBank, getBankMainDetails, putBank } from '../services/httpCalls'
import useNotify from "../utils/useNotify"
import { useLocation } from "react-router-dom"
import { cleanObject } from '../utils/onboarding/clean-object'

export default function SetUpBank() {
    const [bankId, setBankId] = useState()
    const [bankForm, setBankForm] = useState({
        name: "",
        bankStatus: 'ACTIVE',
        opsUserWaitHour: 1,
        midOfficeUserWaitHour: 3,
        backendUserWaitHour: 3,
        startHour: 10,
        stopHour: 19
    })
    const [editFlag, setEditFlag] = useState(false)
    const routerPath = useLocation();
    const pathname = routerPath.pathname;
    let notify = useNotify()
    const postBankFunc = async (e) => {
        e.preventDefault()
        let data = bankForm;
        let cleanData = cleanObject(data);
        if(editFlag){
            await putBank(data, bankId)
            .then((res) => {
                if (res) {
                    notify.success("Successfully updated Bank!")
                }
            })
            .catch((err) => {
                if (err) {
                    notify.error("Not able to create Bank")
                }
            })
        }else{
            await postBank(data)
            .then((res) => {
                if (res) {
                    notify.success("Successfully created Bank")
                    setBankForm({
                        name: "",
                        cbankStatus: 'ACTIVE',
                        opsUserWaitHour: 1,
                        midOfficeUserWaitHour: 3,
                        backendUserWaitHour: 3,
                        startHour: 10,
                        stopHour: 19
                    })
                }
            })
            .catch((err) => {
                if (err) {
                    notify.error("Not able to create Bank")
                }
            })
        }
        
    }

    useEffect(() => {
        const fetchData = async () => {
          let url_ = window.location.pathname;
          if (pathname === "/addbank") {
            setEditFlag(false);
            setBankForm({
                name: "",
                bankStatus: 'ACTIVE',
                opsUserWaitHour: 1,
                midOfficeUserWaitHour: 3,
                backendUserWaitHour: 3,
                startHour: 10,
                stopHour: 19
            });
          } else {
            await preFetchData(url_);
          }
        };
        fetchData();
      }, [pathname]);

      const preFetchData = async (url_) => {
        let id_ = url_.trim();
        id_ = url_.split("/")[2];
        setBankId(id_);
        setEditFlag(true);
        if(!id_){
            return false
        }
        await getBankMainDetails(id_)
        .then((res) => {
            setBankForm({
                name: res?.name,
                bankStatus: 'ACTIVE',
                opsUserWaitHour: res?.opsUserWaitHour,
                midOfficeUserWaitHour: res?.midOfficeUserWaitHour,
                backendUserWaitHour: res?.backendUserWaitHour,
                startHour: res?.startHour,
                stopHour: res?.stopHour
            });
        })
      };
    return (
        <Box sx={{ padding: "1rem" }}>
            <Typography variant="h5" sx={{ paddingBottom: "1rem", fontWeight: 400 }}>
                {editFlag ? "Edit Bank" : "Setup Bank"}
            </Typography>
            <Box component="form" validate onSubmit={(e) => postBankFunc(e)}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <FormControl
                            variant="standard"
                            required
                            sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                        >
                            <InputLabel htmlFor="name">Bank Name</InputLabel>
                            <Input
                                id="name"
                                sx={{ width: "100%" }}
                                value={bankForm["name"]}
                                onChange={(e) => setBankForm({ ...bankForm, [e.target.id]: e.target.value })}
                                required={true}
                                inputProps={{
                                    maxLength:100
                                }}
                            />
                        </FormControl>
                        <FormControl
                            variant="standard"
                            required
                            sx={{ width: "300px", display: "block", marginTop: ".5rem", paddingTop: '2.5rem' }}
                        >
                            <InputLabel htmlFor="opsUserWaitHour">Ops User waiting time</InputLabel>
                            <TextField
                                id="opsUserWaitHour"
                                variant='standard'
                                sx={{ width: "100%" }}
                                value={bankForm["opsUserWaitHour"]}
                                onChange={(e) => setBankForm({ ...bankForm, [e.target.id]: e.target.value })}
                                required={true}
                                type={'number'}
                                InputProps={{
                                    inputProps: {
                                        max: 10, min: 1
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl
                            variant="standard"
                            required
                            sx={{ width: "300px", display: "block", marginTop: ".5rem", paddingTop: '2.5rem' }}
                        >
                            <InputLabel htmlFor="midOfficeUserWaitHour">Mid office user wait time</InputLabel>
                            <TextField
                                id="midOfficeUserWaitHour"
                                variant='standard'
                                sx={{ width: "100%" }}
                                value={bankForm["midOfficeUserWaitHour"]}
                                onChange={(e) => setBankForm({ ...bankForm, [e.target.id]: e.target.value })}
                                required={true}
                                type={'number'}
                                InputProps={{
                                    inputProps: {
                                        max: 3, min: 1
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl
                            variant="standard"
                            required
                            sx={{ width: "300px", display: "block", marginTop: ".5rem", paddingTop: '2.5rem' }}
                        >
                            <InputLabel htmlFor="backendUserWaitHour">Backend user wait time</InputLabel>
                            <TextField
                                id="backendUserWaitHour"
                                variant='standard'
                                sx={{ width: "100%" }}
                                value={bankForm["backendUserWaitHour"]}
                                onChange={(e) => setBankForm({ ...bankForm, [e.target.id]: e.target.value })}
                                required={true}
                                type={'number'}
                                InputProps={{
                                    inputProps: {
                                        max: 3, min: 1
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl
                            variant="standard"
                            required
                            sx={{ width: "300px", display: "block", marginTop: ".5rem", paddingTop: '2.5rem' }}
                        >
                            <InputLabel htmlFor="startHour">Start Hour</InputLabel>
                            <TextField
                                id="startHour"
                                variant='standard'
                                sx={{ width: "100%" }}
                                value={bankForm["startHour"]}
                                onChange={(e) => setBankForm({ ...bankForm, [e.target.id]: e.target.value })}
                                required={true}
                                type={'number'}
                                InputProps={{
                                    inputProps: {
                                        max: 23, min: 0
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl
                            variant="standard"
                            required
                            sx={{ width: "300px", display: "block", marginTop: ".5rem", paddingTop: '2.5rem' }}
                        >
                            <InputLabel htmlFor="stopHour">Stop Hour</InputLabel>
                            <TextField
                                id="stopHour"
                                variant='standard'
                                sx={{ width: "100%" }}
                                value={bankForm["stopHour"]}
                                onChange={(e) => setBankForm({ ...bankForm, [e.target.id]: e.target.value })}
                                required={true}
                                type={'number'}
                                InputProps={{
                                    inputProps: {
                                        max: 23, min: 0
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Button variant="contained" type={'submit'} sx={{ marginTop: '1.5rem' }}>{editFlag ? "Update Bank" : "Setup Bank"}</Button>
            </Box>
        </Box>
    )
}